import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MaterialModule } from './modules/material.module';
import { Ng2FabSpeedDialModule } from 'ng2-fab-speed-dial';

import { DReciboPagoComponente } from './componentes/drecibo-pago.componente';
import { FormatoMonedaDirectiva } from './directivas/formato-moneda.directive';
import { DateInputMaskDirectiva } from './directivas/date-input-mask.directive';
import { FormateoValorPipe } from './pipes/formato-valor.pipe';
import { DOperacionesMatematicasServicio } from './servicios/doperaciones-matematicas.servicio';
import { DEnvioDataServicio } from './servicios/denvio-data.servcio';
import { TabPagoComponent } from '../../tab/tab.component';

@NgModule({
	imports: [
		CommonModule,
		FormsModule,
		FlexLayoutModule,	
		MaterialModule,
		//Ng2FabSpeedDialModule	
	],
  	declarations: [ 
  		DReciboPagoComponente,
  		FormatoMonedaDirectiva,
  		FormateoValorPipe,
  		DateInputMaskDirectiva,
		TabPagoComponent
 	],
 	exports: [ 
 		DReciboPagoComponente
 	],
 	providers: [
 		DOperacionesMatematicasServicio,
		DEnvioDataServicio
 	],
 	/*entryComponents: [
 		DReciboPagoComponente
 	]*/
})
export class DReciboPagoModule { }

export { DReciboPagoComponente } from './componentes/drecibo-pago.componente';
export { DReciboPagoDialogoServicio } from './servicios/drecibo-pago-dialogo-servicio';
export { DEnvioDataServicio } from './servicios/denvio-data.servcio';



// WEBPACK FOOTER //
// D:/GITHUB/F210/V18/rec_ng_renta210v18/src/app/components/recibo-pago/src/integrador.ts